import { connect } from 'react-redux';
import Configuration from '../../components/sections/pluginSettings/Configuration';
import { updateConfiguration } from '../../actions';
import { setLocalStorage } from '../../helpers/tools';

const mapStateToProps = state => {
  return {
    data: state.configuration,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateState: data => {
      if (data.isValid) {
        setLocalStorage('configuration', JSON.stringify(data));
      }
      dispatch(updateConfiguration(data));
    },
  };
};

const ConfigurationRedux = connect(mapStateToProps, mapDispatchToProps)(Configuration);

export default ConfigurationRedux;
